import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { createShallowStore, createStoreWithPersistAndSubscribe } from '@frontend/store';

const defaultColorValues = {
  [NotificationType.SMS]: 'tangerine',
  [NotificationType.SCHEDULE_REQUEST]: 'rose',
  [NotificationType.PAYMENTS]: 'success',
  ['Tags' as NotificationType]: 'critical',
  [NotificationType.VOICEMAIL_MESSAGE]: 'eggplant',
  [NotificationType.CHAT_MESSAGE]: 'indigo',
  [NotificationType.REVIEWS]: 'neutral',
  [NotificationType.FORMS]: 'primary',
  [NotificationType.FAX]: 'warning',
  [NotificationType.TASK]: 'indigo',
};

export interface ForYouNotificationColorsStore {
  forYouNotificationColors: Record<string, string>;
  setForYouNotificationColors: (notificationColors: Record<string, string>) => void;
}

const forYouNotificationColorsStore = createStoreWithPersistAndSubscribe<ForYouNotificationColorsStore>(
  (set) => ({
    forYouNotificationColors: defaultColorValues,
    setForYouNotificationColors: (forYouNotificationColors) =>
      set(
        (state) => {
          state.forYouNotificationColors = forYouNotificationColors;
        },
        false,
        'SET_FOR_YOU_NOTIFICATION_COLORS'
      ),
  }),
  { name: 'ForYouNotificationColors' },
  { name: 'ForYouNotificationColorsStore', trace: true }
);

export const useForYouNotificationColorsStore = createShallowStore(forYouNotificationColorsStore);
